import { Component } from '@angular/core';
import { FieldBaseComponent } from '../field-base';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormFieldErrorComponent } from '../form-field-error/form-field-error.component';

@Component({
  selector: 'lib-form-time',
  styleUrls: ['form-time.component.scss'],
  templateUrl: './form-time.component.html',
  imports: [FormsModule, ReactiveFormsModule, FormFieldErrorComponent],
})
export class FormTimeComponent extends FieldBaseComponent {}
